import type {Repository} from '@github-ui/current-repository'
import {Flash} from '@primer/react'

import {isWeirichCommit} from '../../../utils/weirich-commit'

export function WeirichCommitBanner({oid, repo}: {oid: string; repo: Repository}) {
  if (!isWeirichCommit(oid, repo.id)) {
    return null
  }

  return (
    <Flash className="tmp-mb-4">
      <img
        src="/images/modules/commit/flowers@2x.png"
        alt="flower"
        width="88px"
        height="49px"
        className={'tmp-mr-4 mt-1 float-left'}
      />
      <h2>Thanks for everything, Jim.</h2>
      <p>We will miss you.</p>
    </Flash>
  )
}
